import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getSampleQuizId } from 'libs/api/learning';
import { TModalProps } from 'modules/types';
import { ERoute } from 'enums/route.enum';
import { Modal, Button, Row } from 'antd';

const MembershipInfoModal = ({ modalState, setModalState }: TModalProps) => {
  const [sampleId, setSampleId] = useState<number>();
  const history = useHistory();

  function handleCancel() {
    setModalState({ visible: false });
    // form.resetFields();
  }

  const getSampleQuiz = async () => {
    const { success, data } = await getSampleQuizId();
    if (success) {
      setSampleId(data.sample_quiz_id);
    }
  };

  useEffect(() => {
    if (modalState.visible) {
      getSampleQuiz();
    }
  }, [modalState]);

  return (
    <Modal
      visible={modalState.visible}
      maskClosable={true}
      onCancel={handleCancel}
      width={680}
      centered={true}
      title={
        <div style={{ marginTop: '20px' }}>
          <span
            style={{
              fontSize: '1.75rem',
              fontWeight: 'bolder',
            }}
          >
            유료 멤버십
          </span>
        </div>
      }
      footer={
        <Row justify='space-between'>
          <Button
            onClick={() => {
              if (sampleId) {
                history.push(`/case/quiz/view/${sampleId}`);
                handleCancel();
              }
            }}
          >
            샘플 문제 풀기 (무료)
          </Button>
          <div>
            <Button onClick={handleCancel}>닫기</Button>
            <Button className='ant-btn-primary' onClick={() => history.push(ERoute.CSLearningPurchaseGuide)}>
              Career Step 패스 구매하기
            </Button>
          </div>
        </Row>
      }
    >
      <div style={{ marginBottom: '10px' }}>채점하기와 해설을 이용하려면 Career Step 패스가 필요합니다</div>
    </Modal>
  );
};

export default MembershipInfoModal;
